<template>
  <v-transformer
    :ref="config.name"
    :config="config"
    @transformstart="$emit('transform:start', $event)"
    @transformend="$emit('transform:end', $event)"
  />
</template>

<script>
export default {
  name: 'Transformer',
  props: {
    stageKey: String,
    stageAllowScale: {
      type: Boolean,
      default: true
    },
    stageAllowStretch: {
      type: Boolean,
      default: true
    },
    stageAllowRotate: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      allowScale: true,
      allowStretch: false,
      allowRotate: true,
    }
  },
  computed: {
    config () {
      return {
        name: 'transformer', 
        keepRatio: true, 
        centeredScaling: true,
        rotateEnabled: this.stageAllowRotate && this.allowRotate,
        enabledAnchors: this.enabledAnchors
      }
    },
    enabledAnchors () {
      let result = []
      if (this.stageAllowScale && this.allowScale) result.push('top-left', 'top-right', 'bottom-left', 'bottom-right')
      if (this.stageAllowStretch && this.allowStretch) result.push('top-center', 'middle-right', 'bottom-center', 'middle-left')
      return result
    },
  },
  methods: {
    getTransformer () {
      return this.$refs[this.config.name]?.getNode()
    },
    _setAnchorAllowance ({allowScale, allowStretch, allowRotate}) {
      const [arg] = arguments
      for (let dimension in arg) this.$set(this, dimension, arg[dimension])
    },
    _clearTransformer () {
      const transformer = this.$refs[this.config.name]?.getNode()
      transformer.nodes([])
    },
    _setTransformer ({target}) {
      if (target.name()?.includes('_anchor')) return
      const transformer = this.$refs[this.config.name]?.getNode()
      const stage = transformer.getStage()
      if (stage.attrs.isStatic || target.name() === this.stageKey) {
        transformer.nodes([])
        if (target.name() === this.stageKey) this.$emit('select-stage')
        return
      }
      const {attrs} = target
      const selectedNode = attrs.baseName || attrs.transformerTargetName
        ? transformer.getStage().findOne(n => {
          if (attrs.transformerTargetName) return n.name() === attrs.transformerTargetName
          return n.name() === attrs.baseName
        })
        : null
      const selectedAttrs = selectedNode?.attrs ?? {}
      this.$set(this, 'allowScale', selectedAttrs?.allowTransformerScale ?? true)
      this.$set(this, 'allowStretch', selectedAttrs?.allowTransformerStretch ?? true)
      this.$set(this, 'allowRotate', selectedAttrs?.allowTransformerRotate ?? true)
      if (selectedNode === transformer.node() || selectedNode?.attrs.isStatic) return
      transformer.nodes(selectedNode ? [selectedNode] : [])
    }
  }
}
</script>